/**
 * Main Application File
 *
 * Use for bootstrapping large application
 * or just fill it with JS on small projects
 *
 */

import 'babel-polyfill';
import './components/pagination';
import './components/sectionSlider';
import './components/cookies';

import './layouts/menu';
import './layouts/header';
import './layouts/loader';




// WEBPACK FOOTER //
// ./js/app.js